import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13de45f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "the-global-header-dms shadow" }
const _hoisted_2 = {
  id: "the-global-header-body",
  class: "level is-mobile"
}
const _hoisted_3 = { class: "the-global-header-inner" }
const _hoisted_4 = {
  key: 0,
  href: "https://www.ndl.go.jp/jp/collect/hakuron/index.html"
}
const _hoisted_5 = {
  key: 1,
  href: "https://www.ndl.go.jp/jp/library/supportvisual/supportvisual-10_01.html"
}
const _hoisted_6 = {
  key: 2,
  href: "https://www.ndl.go.jp/jp/collect/online/index.html"
}
const _hoisted_7 = {
  key: 0,
  class: "the-dms-nav has-text-modest"
}
const _hoisted_8 = { class: "the-dms-nav-inner" }
const _hoisted_9 = { class: "the-dms-navi-main" }
const _hoisted_10 = { class: "the-dms-navi-sub" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("パスワード変更")
const _hoisted_12 = {
  key: 1,
  class: "the-dms-nav has-text-modest"
}
const _hoisted_13 = { class: "the-dms-nav-inner" }
const _hoisted_14 = { class: "the-dms-navi-sub" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.path.includes('/doctor/login'))
          ? (_openBlock(), _createElementBlock("a", _hoisted_4, " 国内博士論文の収集について "))
          : (_ctx.path.includes('/supportVisual/login'))
            ? (_openBlock(), _createElementBlock("a", _hoisted_5, " 視覚障害者等用データの収集について "))
            : (_ctx.path.includes('/dms/online') || _ctx.path.includes('/login'))
              ? (_openBlock(), _createElementBlock("a", _hoisted_6, " オンライン資料収集制度について "))
              : _createCommentVNode("", true)
      ]),
      (_ctx.loginUser.id && !(_ctx.path.includes('/dms/online') || _ctx.path.includes('/openinq') || _ctx.path.includes('/dms/author') || _ctx.path.includes('/login')))
        ? (_openBlock(), _createElementBlock("nav", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, _toDisplayString(_ctx.loginUser.id), 1)
              ]),
              _createElementVNode("ul", _hoisted_10, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: { name: 'OuterPasswordEditPage' } }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]), ["space","enter"]))
                  }, " ログアウト ", 32)
                ])
              ])
            ])
          ]))
        : (_ctx.path.includes('/openinq') || _ctx.path.includes('/dms/author'))
          ? (_openBlock(), _createElementBlock("nav", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("ul", _hoisted_14, [
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/dms/online/login'))),
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/online/login')), ["prevent"]), ["space","enter"]))
                    }, " ログイン ", 32)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}